import {
    Flex,
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    Card,
    CardBody,
    CardHeader,
    Heading,
    useDisclosure,
    Spacer,
    useBoolean,
    HStack,
    Input,
    Image
} from "@chakra-ui/react";
import { LichSuGiaDatData } from "../_mocks_";
import { ConfirmModal, Kvhc } from "../components";
import LichSuGiaDatDetail from "../containers/LichSuGiaDatDetail";
import KvhcDatasource from "../_mocks_/kvhc.json";
import { useState, useEffect } from "react";
import { IDropdownItem, ILichSuGiaDat } from "../_types_";
import { getLichSuGiaDat } from "../apis/giadat.api";

export interface IProps { }

const TraCuuLichSuGiaDat = () => {
    const { isOpen, onClose, onOpen } = useDisclosure();
    const [flag, setFlag] = useBoolean();
    const [huyenSelected, setMaHuyen] = useState<string | undefined>();
    const [xaSelected, setMaXa] = useState<string | undefined>();
    const [searchThua, setSearchThua] = useState<number | undefined>();
    const [searchTo, setSearchTo] = useState<number | undefined>();
    const [searchVal, setSearchVal] = useState<string>();
    const [searchTuNam, setSearchTuNam] = useState<number>();
    const [searchDenNam, setSearchDenNam] = useState<number>();
    const [giaDats, setGiaDats] = useState<ILichSuGiaDat[]>(LichSuGiaDatData);
    const [kvhcCapHuyen] = useState<IDropdownItem[]>(() => {
        const huyenS = KvhcDatasource.map((kv) => {
            const item: IDropdownItem = {
                lable: kv.tenHuyen,
                value: kv.maHuyen,
            };
            return item;
        });
        setMaHuyen(huyenS[0].value.toString());
        return huyenS;
    });
    const [kvhcCapXa, setKvhcCapXa] = useState<IDropdownItem[]>([]);

    useEffect(() => {
        if (huyenSelected) {
            const huyen = KvhcDatasource.find((p) => p.maHuyen === huyenSelected);
            const xaS = !huyen
                ? []
                : huyen.xas.map((xa) => {
                    const item: IDropdownItem = {
                        lable: xa.tenXa,
                        value: xa.maXa,
                    };
                    return item;
                });
            setKvhcCapXa(xaS);
            setMaXa(xaS[0].value?.toString());
        }
    }, [huyenSelected]);

    useEffect(() => {
    }, [xaSelected]);

    useEffect(() => {
        if (!searchVal) {
            setSearchTo(undefined);
            setSearchThua(undefined);
            return;
        }
        const toThua = searchVal.toString().split("/");
        setSearchTo(toThua[0] ? Number(toThua[0]) : undefined);
        setSearchThua(toThua[1] ? Number(toThua[1]) : undefined);
    }, [searchVal]);

    const handleSearch = async () => {
        try {
            if (!huyenSelected || !xaSelected) return;
            let data = await getLichSuGiaDat(huyenSelected, xaSelected, searchTo, searchThua, searchTuNam ?? undefined, searchDenNam ?? undefined);
            setGiaDats(data);
        } catch (er) {
            setGiaDats([]);
        }
    };

    return (
        <Flex w="full" bg="whiteAlpha.900">
            <Card w="full">
                <CardHeader>
                    <Flex>
                        <Heading as="h3" textTransform="uppercase" >Tra cứu lịch sử giá đất</Heading>
                        <Spacer />
                        {/* <Button bg="green" size="sm" onClick={() => setFlag.on()}>
                            <AddIcon color="white" />
                            <Text ml="10px" color="white">
                                Thêm lịch sử giá đất
                            </Text>
                        </Button> */}
                    </Flex>
                    <HStack as="div">
                        <HStack>
                            <Kvhc
                                data={kvhcCapHuyen}
                                selectedValue={huyenSelected}
                                defaultLabel="--- Chọn huyện/thành phố ---"
                                onValueChange={(val) => setMaHuyen(val?.toString())}
                            />
                            <Kvhc
                                data={kvhcCapXa}
                                selectedValue={xaSelected}
                                defaultLabel="--- Chọn phường/quận ---"
                                onValueChange={(val) => setMaXa(val?.toString())}
                            />
                        </HStack>
                        <HStack bg="white" border="1px solid #f1f1f1">
                            <HStack px="10px" bg="white">
                                <Input
                                    _focusVisible={{ outline: "none" }}
                                    border="none"
                                    placeholder="Từ năm"
                                    type='number'
                                    onChange={(e) => { setSearchTuNam(isNaN(e.target.valueAsNumber) ? undefined : e.target.valueAsNumber) }}
                                    color="#333"
                                />
                                <Input
                                    _focusVisible={{ outline: "none" }}
                                    border="none"
                                    placeholder="Đến năm"
                                    type='number'
                                    onChange={(e) => { setSearchDenNam(isNaN(e.target.valueAsNumber) ? undefined : e.target.valueAsNumber) }}
                                    color="#333"
                                />
                                <Input
                                    _focusVisible={{ outline: "none" }}
                                    border="none"
                                    placeholder="Nhập tờ/thửa"
                                    onChange={(e) => setSearchVal(e.target.value)}
                                    color="#333"
                                />
                            </HStack>
                            <Flex onClick={handleSearch} px="20px" py="10px" cursor="pointer">
                                <Image src="./imgs/search.svg" alt="search" />
                            </Flex>
                        </HStack>
                    </HStack>
                </CardHeader>
                <CardBody>
                    <TableContainer w="full">
                        <Table variant="simple">
                            <Thead>
                                <Tr>
                                    <Th>Số tờ</Th>
                                    <Th>Số thửa</Th>
                                    <Th>Định giá</Th>
                                    <Th>Giá hợp đồng</Th>
                                    <Th>Giá thị trường</Th>
                                    <Th>Tên đường chính</Th>
                                    <Th>Phương pháp định giá</Th>
                                    <Th>Ngày định giá</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {giaDats.map((giaDat) => (
                                    <Tr>
                                        <Td>{giaDat.soTo}</Td>
                                        <Td>{giaDat.soThua}</Td>
                                        <Td>{giaDat.tongGia}</Td>
                                        <Td>{giaDat.tongGia}</Td>
                                        <Td>{giaDat.giaThiTruong}</Td>
                                        <Td>{giaDat.tenDuong}</Td>
                                        <Td>{giaDat.phuongPhapDinhGia}</Td>
                                        <Td>{giaDat.modifiedDate ? new Date(giaDat.modifiedDate).toLocaleDateString('vi-VN') : ''}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>
                </CardBody>
            </Card>
            <ConfirmModal isOpen={isOpen} onClose={onClose} onOk={onClose} />
            <LichSuGiaDatDetail isOpen={flag} onClose={() => setFlag.off()} />
        </Flex>
    );
};

export default TraCuuLichSuGiaDat;
